module.exports = __webpack_public_path__ + "img/6.1.47b14ec0.png";